import { Plus } from 'lucide-react';

import { Button } from '@nesso/ui/primitives/button';
import { Calendar } from '@nesso/ui/primitives/calendar';

import { openScheduleSession } from '@/features/session/schedule-session';

type Props = {
    selectedDay: Date;
    shownMonth: Date;
    today: Date;
    selectDay: (day: Date) => void;
    showMonth: (month: Date) => void;
    isExpired: boolean;
};

export function CalendarPageSidebar({
    selectedDay,
    shownMonth,
    today,
    selectDay,
    showMonth,
    isExpired,
}: Props) {
    return (
        <div className="flex flex-col gap-2">
            {!isExpired && (
                <Button
                    variant="outline"
                    size="lg"
                    className="mx-3 mt-4 w-fit"
                    onClick={() => openScheduleSession()}
                >
                    <Plus aria-hidden="true" />
                    Create
                </Button>
            )}
            <Calendar
                className="w-full p-3"
                cellSize="md"
                dayStyle="accent"
                animate
                mode="single"
                required
                selected={selectedDay}
                onSelect={selectDay}
                month={shownMonth}
                today={today}
                onMonthChange={showMonth}
            />
        </div>
    );
}
